import Axios from "axios";
var WarehouseService = (function () {
    function WarehouseService() {
    }
    WarehouseService.createInstance = function () {
        WarehouseService.getInstance();
    };
    WarehouseService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    WarehouseService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/suppliertransfer/list", { params: params });
    };
    WarehouseService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/suppliertransfer/detail", { params: params });
    };
    WarehouseService.prototype.addUpperwarehouse = function (params) {
        return Axios.post("supplierclientapi/suppliertransfer/save_transfer", params);
    };
    WarehouseService.prototype.getSupplierdepotList = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/list", { params: params });
    };
    WarehouseService.prototype.audit = function (params) {
        return Axios.get("supplierclientapi/suppliertransfer/do_audit", { params: params });
    };
    WarehouseService.prototype.discard = function (params) {
        return Axios.get("/supplierclientapi/suppliertransfer/do_cancel", { params: params });
    };
    WarehouseService.prototype.create = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/list", { params: params });
    };
    WarehouseService.prototype.getOrgandepotOptions = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_organdepot_options", { params: params });
    };
    WarehouseService.prototype.getSupplierupperOptions = function (params) {
        return Axios.get("supplierclientapi/supplierupper/get_options", { params: params });
    };
    WarehouseService.prototype.getAccountOptions = function (params) {
        return Axios.get("supplierclientapi/account/get_options", { params: params });
    };
    WarehouseService.prototype.getSupplierorganOptions = function (params) {
        return Axios.get("supplierclientapi/supplierorgan/get_options", { params: params });
    };
    WarehouseService.prototype.getSupplierdepotOptions = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_options", { params: params });
    };
    WarehouseService.prototype.getStockinitGoodslist = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/get_goods_or_stock_list", params);
    };
    WarehouseService.prototype.deleteStockinitGoodslist = function (params) {
        return Axios.get("supplierclientapi/upperwarehouse/delete_detail", { params: params });
    };
    return WarehouseService;
}());
export default WarehouseService;
